import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchWorkspaceClosure } from '@/api/workspaceClosure/workspaceClosureApi';
import type { WorkspaceClosure } from '@/api/workspaceClosure/workspaceClosureApi.types';
import { WORKSPACE_CLOSURE_QUERY_KEY } from '@/constants/queryKeys';

export function useWorkspaceClosureQuery(): UseQueryResult<WorkspaceClosure, Error> {
  return useQuery({
    queryKey: WORKSPACE_CLOSURE_QUERY_KEY,
    queryFn: fetchWorkspaceClosure,
  });
}
